import { render } from "./AuthorizationView.vue?vue&type=template&id=135c31da"
import script from "./AuthorizationView.vue?vue&type=script&lang=js"
export * from "./AuthorizationView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__